function defaultSetRem(): void {
    const baseSize = 16;
    // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
    const scale = document.documentElement.clientWidth / 750;
    // 设置页面根节点字体大小
    // 1.36 = 1024(根元素的最大宽度) / 750(设计稿宽度)
    // 0.37 = 280(根元素的最小宽度) / 750(设计稿宽度)
    const htmlStyle = `
        font-size: ${baseSize * Math.min(scale > 0.37 ? scale : 0.37, 1.36)}px;
        max-width: 1024px;
        min-width: 280px;
        margin: 0 auto;
    `;

    document.documentElement.style.cssText = htmlStyle;
}

export default function setRem(): void {
    defaultSetRem();
    window.onresize = (): void => {
        defaultSetRem();
    };
}
